import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import * as ROUTES from "../../constans/rutas";
import { consultarAuditLog } from "./consultarAuditLog";
import {
  extraerListaAuditLog,
  normalizarRegistroAuditLog,
  ordenarPorFechaDesc,
} from "./normalizarAuditLog";
import {
  construirResumenPorUsuarioAccion,
  etiquetaParqueaderos,
  etiquetaPeriodo,
  filtrarDetalleUsuarioAccion,
  filtrarUsuariosValidos,
  filtrosDiaActual,
  ocultarAuditoriaClientes,
} from "./resumenAuditLog";
import AuditoriaFiltroForm from "./AuditoriaFiltroForm";
import AuditoriaResumenTable from "./AuditoriaResumenTable";
import AuditoriaTable from "./AuditoriaTable";
import "../Planillas/cierreTurno/CierreTurno.css";
import "./Auditoria.css";

const mensajeErrorApi = (error) => {
  const data = error.response && error.response.data;
  if (!data) return error.message || "Error al consultar auditoría.";
  if (Array.isArray(data.message)) return data.message.join(" ");
  return data.message || data.error || error.message || "Error al consultar auditoría.";
};

const AuditoriaPage = () => {
  const history = useHistory();
  const [filtros, setFiltros] = useState(filtrosDiaActual);
  const [registros, setRegistros] = useState([]);
  const [total, setTotal] = useState(0);
  const [parqueaderos, setParqueaderos] = useState([]);
  const [terminalesCc, setTerminalesCc] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState("");
  const [consultaHecha, setConsultaHecha] = useState(false);
  const [periodoConsultado, setPeriodoConsultado] = useState(filtrosDiaActual);
  const [seleccion, setSeleccion] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFiltros((prev) => ({ ...prev, [name]: value }));
  };

  const buscar = useCallback(async (filtrosConsulta) => {
    if (
      filtrosConsulta.fechaDesde &&
      filtrosConsulta.fechaHasta &&
      filtrosConsulta.fechaDesde > filtrosConsulta.fechaHasta
    ) {
      setError("La fecha desde no puede ser mayor que la fecha hasta.");
      return;
    }

    setCargando(true);
    setError("");
    setSeleccion(null);
    try {
      const payload = await consultarAuditLog(filtrosConsulta);
      const {
        registros: lista,
        parqueaderos: parksApi,
        terminales: termsApi,
      } = extraerListaAuditLog(payload);
      const normalizados = ocultarAuditoriaClientes(
        ordenarPorFechaDesc(lista.map(normalizarRegistroAuditLog))
      );
      setRegistros(normalizados);
      setTotal(normalizados.length);
      setParqueaderos(parksApi);
      setTerminalesCc(termsApi);
      setPeriodoConsultado({ ...filtrosConsulta });
      setConsultaHecha(true);
    } catch (err) {
      console.error("Error consultando audit_log:", err);
      setRegistros([]);
      setTotal(0);
      setParqueaderos([]);
      setTerminalesCc([]);
      setConsultaHecha(true);
      setError(mensajeErrorApi(err));
    } finally {
      setCargando(false);
    }
  }, []);

  useEffect(() => {
    buscar(filtrosDiaActual());
  }, [buscar]);

  const handleSubmit = (e) => {
    e.preventDefault();
    buscar(filtros);
  };

  const handleClear = () => {
    const hoy = filtrosDiaActual();
    setFiltros(hoy);
    buscar(hoy);
  };

  const resumen = useMemo(
    () => construirResumenPorUsuarioAccion(registros),
    [registros]
  );

  const registrosValidos = useMemo(
    () => filtrarUsuariosValidos(registros),
    [registros]
  );

  const detalleSeleccionado = useMemo(() => {
    if (!seleccion) return [];
    return ordenarPorFechaDesc(
      filtrarDetalleUsuarioAccion(
        registros,
        seleccion.usuario,
        seleccion.accion
      )
    );
  }, [registros, seleccion]);

  const nombreParkEtiqueta = useMemo(
    () => etiquetaParqueaderos(parqueaderos),
    [parqueaderos]
  );

  const handleSeleccionar = (row) => {
    setSeleccion((prev) =>
      prev && prev.usuario === row.usuario && prev.accion === row.accion
        ? null
        : { usuario: row.usuario, accion: row.accion }
    );
  };

  return (
    <div className="cierre-turno-container">
      <div className="auditoria-header">
        <h2 className="cierre-turno-title">Auditoría</h2>
        <button
          type="button"
          className="auditoria-volver"
          onClick={() => history.push(ROUTES.PLANILLAS)}
        >
          ← Volver al Panel Principal
        </button>
      </div>

      <AuditoriaFiltroForm
        filtros={filtros}
        onChange={handleChange}
        onSubmit={handleSubmit}
        onClear={handleClear}
        cargando={cargando}
      />

      {error ? <div className="auditoria-error">{error}</div> : null}

      {consultaHecha &&
      !error &&
      String(periodoConsultado.centroCostos || "").trim() ? (
        <div className="auditoria-cc-meta">
          <strong>Centro de costos {periodoConsultado.centroCostos.trim()}</strong>
          {nombreParkEtiqueta ? (
            <span> · Parqueadero: {nombreParkEtiqueta}</span>
          ) : (
            <span> · Sin parqueadero asociado</span>
          )}
          {terminalesCc.length > 0 ? (
            <span>
              {" "}
              · Terminales: {terminalesCc.join(", ")}
            </span>
          ) : (
            <span> · Sin terminales asociadas</span>
          )}
        </div>
      ) : null}

      {consultaHecha && !error ? (
        <p className="auditoria-resumen">
          {cargando
            ? "Consultando registros..."
            : `Resumen por usuario y acción · periodo: ${etiquetaPeriodo(
                periodoConsultado.fechaDesde,
                periodoConsultado.fechaHasta
              )} · ${resumen.length} grupo(s) · ${
                registrosValidos.length
              } registro(s) con usuario${
                total > registros.length ? ` (${total} en API)` : ""
              }.`}
        </p>
      ) : null}

      {cargando && !consultaHecha ? (
        <div className="no-results">Cargando auditoría...</div>
      ) : error ? null : (
        <>
          <AuditoriaResumenTable
            resumen={resumen}
            seleccion={seleccion}
            onSeleccionar={handleSeleccionar}
          />

          {seleccion ? (
            <section className="auditoria-detalle-panel">
              <div className="auditoria-detalle-panel__header">
                <h3>
                  Detalle: {seleccion.usuario} · {seleccion.accion} (
                  {detalleSeleccionado.length})
                </h3>
                <button
                  type="button"
                  className="btn-secondary"
                  onClick={() => setSeleccion(null)}
                >
                  Cerrar detalle
                </button>
              </div>
              <AuditoriaTable registros={detalleSeleccionado} />
            </section>
          ) : consultaHecha && resumen.length > 0 ? (
            <p className="auditoria-hint">
              Haz clic en una fila del resumen para ver el detalle de la base de
              datos.
            </p>
          ) : null}
        </>
      )}
    </div>
  );
};

export default AuditoriaPage;
